import { FirebaseActions, logger } from '@web_opxp/features';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Action, Dispatch } from 'redux';
import useRedirect from '../base/useRedirect';
import Banner from './banner/Banner';
import BridgePopup from './bridgePopup/BridgePopup';
import useExperimentControl from './useExperimentControl';
import useNavigationBlocker from './useNavigationBlocker';
import { redirectToMed } from './utils';

export default function MedBannerController() {
  const [dialog, setDialog] = useState(false);
  const { blockNavigation, unblockNavigation } = useNavigationBlocker();
  const [started, showBanner, showBridge, , bridgeShown] = useExperimentControl();
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const { redirectToTraining } = useRedirect();

  const blockHandler = useCallback(() => {
    setDialog(true);
  }, []);

  const okClickHandler = () => {
    dispatch(
      FirebaseActions.analyticsEvent({
        eventName: 'v_followup_sub_cta',
        parameters: [{ key: 'Campaign', value: 'med' }],
      })
    );
    unblockNavigation();
    bridgeShown();
    setDialog(false);
    redirectToMed();
  };

  const bannerClickedHandler = () => {
    dispatch(
      FirebaseActions.analyticsEvent({
        eventName: 'v_banner_clicked',
        parameters: [
          { key: 'Location', value: 'Subscribe' },
          { key: 'Campaign', value: 'Med' },
        ],
      })
    );
    unblockNavigation();
    redirectToMed();
  };

  const bridgeBackClickHandler = () => {
    dispatch(
      FirebaseActions.analyticsEvent({
        eventName: 'v_followup_sub_skip',
        parameters: [{ key: 'Campaign', value: 'med' }],
      })
    );
    unblockNavigation();
    bridgeShown();
    setDialog(false);
    redirectToTraining();
  };

  useEffect(() => {
    if (!started) {
      return;
    }
    logger(['MedBannerController', showBridge]);
    if (!showBridge) {
      unblockNavigation();
      return;
    }
    // block navigation
    blockNavigation(blockHandler);
  }, [started, showBridge, blockHandler, blockNavigation, unblockNavigation]);
  return (
    <>
      <Banner show={showBanner} onClick={bannerClickedHandler} />
      <BridgePopup show={dialog} onBackClick={bridgeBackClickHandler} onOKClick={okClickHandler} />
    </>
  );
}
